import React from 'react'
import ErrorModal from '../../../CustomAlerts/ErrorModal'

const FailPayment = () => {
  return (
   <ErrorModal msg={'Payment Failed'} route={'/Assessments'}/>
  )
}

export default FailPayment